import { create } from 'zustand';

export interface IToFunnelStore {
  initFunnelPayload: any;
  setInitFunnelPayload: (initFunnelPayload: any) => void;
}

const useToFunnelStore = create<IToFunnelStore>((set) => ({
  initFunnelPayload: {},
  setInitFunnelPayload: (initFunnelPayload: any) => set(() => ({ initFunnelPayload })),
}));

export default useToFunnelStore;
